<template>
  <div class="analysis">
    <div ref="topic" class="fx">
      <topic-content
        :isAssignShow="isAssignShow"
        :questionList="questionList"
        :type="type"
        :overviewData="overviewData"
        :changeData="changeData"
        ref="content"
        @layoutTopic="layoutTopic"
      />
    </div>
    <div ref="box"></div>
    <div ref="filter" class="over" :class="isFixed== true?'isFixed':''">
      <topic-filter
        class="analysis-topic"
        :titleList="titleList"
        @jumpTopic="jumpTopic"
        :questionId="questionId"
      />
    </div>
     <!-- 布置错题巩固弹框 -->
    <assign-mistakes
      :isAssignShow.sync="isAssignShow"
      :topic='topic'
      @clearchange="clearchange"
      @clearList="clearList"
      :requestCondition="requestCondition"
    />
  </div>
</template>

<script>
import TopicFilter from './topic-filter.vue';
import { getQuestionAnalysisList } from '@/api/pt';
import TopicContent from './topic-content.vue';
import AssignMistakes from '../../components/assign-mistakes.vue';

export default {
  name: 'TopicAnalysis',
  components: {
    TopicFilter,
    TopicContent,
    AssignMistakes,
  },
  props: {
    overviewData: {
      type: Object,
      default: () => {},
    },
    changeData: {
      type: Object,
      default: () => {},
    },
    questionId: {},
  },
  data() {
    return {
      isFixed: false,
      questionList: [],
      titleList: [],
      isAssignShow: false,
      topic: [],
      type: true,
      requestCondition: {
        classType: 2,
        testType: 4,
      },
    };
  },
  mounted() {
    this.getQuestionAnalysisList();
    window.addEventListener('scroll', this.handleScroll, true);
  },
  methods: {
    handleScroll() {
      this.$nextTick(() => {
        const headerTop = this.$refs.filter && this.$refs.filter.getBoundingClientRect().top;
        const contentTop = this.$refs.topic && this.$refs.topic.getBoundingClientRect().top;
        const width = this.$refs.filter.clientWidth;
        const topicWidth = this.$refs.topic.clientWidth + 30;
        if (contentTop > 0) {
          this.$refs.box.style.width = '0px';
          this.isFixed = false;
        }
        if (headerTop < 0) {
          this.$refs.filter.style.right = `-${topicWidth}px`;
          console.log(width, topicWidth, this.$refs.filter.style);
          this.$refs.box.style.width = `${width}px`;
          this.isFixed = true;
        }
      });
    },
    async getQuestionAnalysisList() {
      try {
        const userInfo = JSON.parse(localStorage.getItem('CRM_USER_INFO')) || {};
        const data = {
          school_id: userInfo.campusId,
          class_id: this.changeData.class_id || this.overviewData.class_id,
          evaluate_id: this.changeData.evaluate_id || this.overviewData.evaluate_id,
          course_id: this.changeData.course_id || this.overviewData.course_id,
          subject_id: this.changeData.subject_id || this.overviewData.subject_id,
        };
        const res = await getQuestionAnalysisList(data);
        this.questionList = res.data.question_list;
        this.titleList = res.data.right_rate;
      } catch (err) {
        console.log(err);
      }
    },
    layoutTopic(list) { // 布置
      this.topic = list;
      this.$set(this.requestCondition, 'className', this.overviewData.class_name);
      this.$set(this.requestCondition, 'classId', this.overviewData.class_id);
      this.$set(this.requestCondition, 'subjectName', this.overviewData.subject_name);
      this.isAssignShow = true;
    },
    jumpTopic(kitem) { // 跳转到特定题
      const anchor = document.getElementById(`#${kitem.question_id}`);
      // chrome
      this.$nextTick(() => {
        console.log(kitem.question_id, 'id');
        anchor.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
        this.$refs.content.jumpTopic(kitem.question_id);
      });
    },
    clearList(type) {
      this.type = type;
    },
    clearchange() {
      this.topic = [];
    },
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll, true);
  },
};
</script>

<style lang="scss" scoped>
  .analysis {
    display: flex;
    &-wrong {
      flex: 1;
    }
    &-topic {
      width: 280px;
    }
  }
  .fx {
    flex: 1;
  }
  .isFixed{
    position: fixed;
    top: 0px;
    height: 90vh;
    right: 0vw;
    z-index: 4;
    width: 100%;
  }
  .over {
    height: 70vh;
    overflow: hidden;
    margin-top: 30px;
  }
</style>
